import React from "react";
import MarkdownTranslation from "components/shared/MarkdownTranslation";
import { useFormContext } from "react-hook-form";
import CheckboxFieldWrapper from "components/shared/form/fields/CheckboxFieldWrapper";
import Checkbox from "components/shared/form/fields/Checkbox";
import TextInput from "components/shared/form/fields/TextInput";
import TextEditor from "components/shared/form/fields/TextEditor";
import Select from "components/shared/form/fields/Select";
import DirectoryPickerInput from "components/shared/form/fields/DirectoryPickerInput";
import { filter, map } from "lodash";

export default function JoinSettings() {
  const { watch } = useFormContext();

  const join_user_can_initiate = watch("join_user_can_initiate");
  const join_promote_groups = watch("group_promotion_config.active");
  const decorators = watch("group_promotion_config.decorators");
  const decorators_external = watch(
    "group_promotion_config.decorators_external",
  );

  return (
    <>
      <h3>
        {I18n.t("js.administration.network_settings.join_settings.title")}
      </h3>
      <div className="form-horizontal">
        {I18n.t("js.administration.network_settings.join_settings.hint") !==
          "no_content_do_not_change" && (
          <div className="alert alert-info">
            {I18n.t("js.administration.network_settings.join_settings.hint")}
          </div>
        )}
        <CheckboxFieldWrapper label={I18n.t("js.networks.join_settings.label")}>
          <Checkbox
            name="join_user_can_initiate"
            label={I18n.t("js.networks.join_settings.user_can_initiate")}
          />
          {join_user_can_initiate && (
            <>
              <Checkbox
                name="join_moderated"
                label={I18n.t("js.networks.join_settings.moderated")}
              />
              <Checkbox
                name="altcha_captcha"
                label={I18n.t("js.networks.join_settings.altcha_captcha")}
              />
              {Tixxt.currentNetwork.getConfig("guest_users.allowed") && (
                <Checkbox
                  name="join_as_external"
                  label={I18n.t("js.networks.join_settings.as_external")}
                />
              )}
            </>
          )}
          <Checkbox
            name="join_ask_for_profile_data"
            label={I18n.t("js.networks.join_settings.ask_for_profile_data")}
          />
          {Preload.current_network.config.extended_group_categories_enabled && (
            <Checkbox
              name="join_section_admins_can_invite_users"
              label={I18n.t(
                "js.networks.join_settings.section_admins_can_invite_users",
              )}
            />
          )}
          <Checkbox
            name="group_promotion_config.active"
            label={I18n.t("js.networks.join_settings.join_promote_groups")}
          />
        </CheckboxFieldWrapper>

        {join_promote_groups && (
          <div className="flex flex-col gap-4">
            <div className="group_promotion_settings flex flex-col gap-4">
              <h4>{I18n.t("js.networks.group_promotion.headline")}</h4>

              <div className="help-block !mb-3">
                {I18n.t("js.networks.group_promotion.help_text")}
              </div>
              {decorators && (
                <div className="help-block !mb-3 mt-1">
                  <span className="text-warning">
                    {I18n.t("js.networks.group_promotion.decorators_help")}
                  </span>
                </div>
              )}

              <TextInput
                name="group_promotion_config.title"
                label={I18n.t("js.networks.group_promotion.title.label")}
                hint={I18n.t("js.networks.group_promotion.title.help")}
                required
              />

              <TextEditor
                name="group_promotion_config.description"
                label={I18n.t("js.networks.group_promotion.description.label")}
                hint={I18n.t("js.networks.group_promotion.description.help")}
              />

              <Select
                name="group_promotion_config.group_category_ids"
                label={I18n.t(
                  "js.networks.group_promotion.group_categories.label",
                )}
                hint={I18n.t(
                  "js.networks.group_promotion.group_categories.help",
                )}
                options={map(
                  filter(
                    Preload.current_network.group_categories,
                    (gc) => !gc.hidden && gc.access != "hidden",
                  ),
                  (gc) => ({
                    value: gc.id,
                    label: gc.plural_name,
                  }),
                )}
                multi
              />

              <DirectoryPickerInput
                name="group_promotion_config.groups"
                label={I18n.t("js.networks.group_promotion.groups.label")}
                hint={I18n.t("js.networks.group_promotion.groups.help")}
                query={{ groups_only: true }}
                multi
              />

              {Preload.current_network.config.guest_users.allowed && (
                <CheckboxFieldWrapper
                  label={I18n.t(
                    "js.networks.group_promotion.enabled_for_external.label",
                  )}
                  hint={I18n.t(
                    "js.networks.group_promotion.enabled_for_external.help",
                  )}
                >
                  <Checkbox
                    name="group_promotion_config.enabled_for_external"
                    label={I18n.t(
                      "js.networks.group_promotion.enabled_for_external.choice",
                    )}
                  />
                  {decorators_external && (
                    <div className="help-block !mb-3 mt-1">
                      <span className="text-warning">
                        {I18n.t(
                          "js.networks.group_promotion.enabled_for_external.decorators_help",
                        )}
                      </span>
                    </div>
                  )}
                </CheckboxFieldWrapper>
              )}
            </div>
          </div>
        )}

        {Tixxt.currentNetwork.getConfig("devise.login_form_configurable") && (
          <div className="flex flex-col gap-4">
            <div>
              <h4>{I18n.t("js.networks.join_settings.login_form")}</h4>

              <MarkdownTranslation
                styles="help-block !mb-3"
                translation={"js.networks.join_settings.login_form_hint_md"}
              />
            </div>

            <TextEditor
              name="devise_text_before"
              label={I18n.t(
                "js.networks.join_settings.label_devise_text_before",
              )}
            />
            <TextEditor
              name="devise_text_between"
              label={I18n.t(
                "js.networks.join_settings.label_devise_text_between",
              )}
            />
            <TextEditor
              name="devise_text_after"
              label={I18n.t(
                "js.networks.join_settings.label_devise_text_after",
              )}
            />
          </div>
        )}
      </div>
    </>
  );
}
